import { createFileRoute } from '@tanstack/react-router';
import AccountingDetailView from '../accounting/AccountingDetailView';
export const Route = createFileRoute('/accounting/$type/$guid')({
  component: AccountingDetailView,
});
